const selectZoneShapeTypes = state => state.data.zoneShapeTypes

const ZoneShapeTypeDataStoreSelectors = {
  zoneShapeTypes: selectZoneShapeTypes
}

export default ZoneShapeTypeDataStoreSelectors
